module.exports = __webpack_public_path__ + "static/media/graphicHomePage.a9e15d99.JPG";